<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 产品管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>产品系列</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.typeId" placeholder="请选择产品类型" style="width:160px;" filterable>
					<el-option key="" label="请选择产品类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.manufacturerId" placeholder="请选择品牌" style="width:160px;" filterable>
					<el-option key="" label="请选择品牌" value=""></el-option>
					<el-option v-for="item in manufacturerKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.name" placeholder="系列名称" class="handle-input" style="width:160px;"></el-input>&nbsp;
				<el-select v-model="query.frontVisible" placeholder="前端是否显示" style="width:130px;">
					<el-option key="" label="请选择前端是否显示" value=""></el-option>
					<el-option key="true" label="显示" value="true"></el-option>
					<el-option key="false" label="不显示" value="false"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.commonUse" placeholder="是否首页展示" style="width:130px;">
					<el-option key="" label="请选择是否首页展示" value=""></el-option>
					<el-option key="true" label="展示" value="true"></el-option>
					<el-option key="false" label="不展示" value="false"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.hasReplace" placeholder="是否停产" style="width:120px;">
					<el-option key="" label="请选择是否停产" value=""></el-option>
					<el-option key="false" label="在产" value="false"></el-option>
					<el-option key="true" label="停产" value="true"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExport" v-if = "controll['export']">导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="系列名称" width = "230px"></el-table-column>
                <el-table-column prop="typeId" label="类型" :formatter = "productTypeFormat"></el-table-column>
				<el-table-column prop="manufacturerId" label="品牌" :formatter = "brandFormat"></el-table-column>
				<el-table-column prop="producer" label="产地" ></el-table-column>
				<el-table-column prop="hasReplace" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="frontVisible" label="前端是否显示">
					<template slot-scope="scope">
                        {{scope.row.frontVisible?"是":"否"}}
                    </template>
				</el-table-column>
				<el-table-column prop="commonUse" label="首页展示">
					<template slot-scope="scope">
                        {{scope.row.commonUse?"是":"否"}}
                    </template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							 v-if = "controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							 v-if = "controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-prevent-re-click
					v-if = "controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if = "controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		<el-dialog title="导出" :visible.sync="exportVisible" width="30%">
			<el-form ref="exportQuery" :model="exportQuery" label-width="50px">
				<el-form-item label="">
					<el-checkbox v-model="exportQuery.exportSeries" disabled placeholder="导出产品系列">导出产品系列</el-checkbox> 
				</el-form-item>
				<el-form-item label="">
					<el-checkbox v-model="exportQuery.exportMapping" placeholder="导出产品关系映射">导出产品关系映射</el-checkbox> 
				</el-form-item>
				<el-form-item label="">
					<el-checkbox v-model="exportQuery.exportProductHTML" placeholder="导出产品HTML页面">导出产品HTML页面</el-checkbox> 
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="exportVisible = false">取 消</el-button>
				<el-button type="primary" @click="exportData" v-prevent-re-click>确 定</el-button>
			</span>
		</el-dialog>
		
        <!-- 编辑弹出框 -->
        <el-dialog :title="title" :visible.sync="editVisible" width="60%">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span=12>
						<el-form-item label="产品类型" prop="typeId">
							<el-select v-model="form.typeId" placeholder="请选择产品类型" filterable>
								<el-option key="" label="请选择产品类型" value=""></el-option>
								<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span=12>
						<el-form-item label="品牌" prop="manufacturerId">
							<el-select v-model="form.manufacturerId" placeholder="请选择品牌" filterable>
								<el-option key="" label="请选择品牌"></el-option>
								<el-option v-for="item in manufacturerKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span=12>
						<el-form-item label="系列名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span=12>
						<el-form-item label="分类细化" prop="subTypeName">
							<el-input v-model="form.subTypeName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="图片" prop="img">
					<el-upload
						class="upload-demo"
						multiple = "false"
						:before-upload="beforeUpload"
						:action= "uploadUrl"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						:file-list="fileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="前端显示" prop="frontVisible">
					<el-radio-group v-model="form.frontVisible">
						<el-radio :label=true>显示</el-radio>
						<el-radio :label=false>不显示</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="首页展示" prop="commonUse" v-if="form.frontVisible">
					<el-radio-group v-model="form.commonUse">
						<el-radio :label=true>是</el-radio>
						<el-radio :label=false>不是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="是否停产被替代" prop="hasReplace">
							<el-radio-group v-model="form.hasReplace">
								<el-radio :label=false>在产</el-radio>
								<el-radio :label=true>停产</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="替代型号" prop="replaceName" v-if="form.hasReplace">
							<el-input v-model="form.replaceName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="产地" prop="producer">
					<el-input v-model="form.producer"></el-input>
				</el-form-item>
				<el-form-item label="特点" prop="characteristic">
					<el-input type=textarea :rows=5 v-model="form.characteristic"> </el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
			</span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false :visible.sync="buildBarVisible" :show-close="false" width="280px">
            <el-progress type="circle" :percentage="progressAge" :stroke-width = "15" :width = "200" style="padding-left:20px;padding-right:20px;padding-buttom:20px;"></el-progress>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchProductSeriesData, saveProductSeries, deleteProductSeries, getProductSeries, getEnumValueKV, 
getManufacturerKV, exportProductSeries, buildHTML, buildMapping } from '../../../api/index';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import {quillRedefine} from 'vue-quill-editor-upload'
//manufacturerId: [{ required: true, message: '请选择品牌', trigger: 'blur' }],
export default {
    name: 'product-series',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10,
				event:"htmlBuildProgressInProductSeries"
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			productTypeEnumCode:1003,
			productTypeKV:{},
			manufacturerKV:{},
			title:"",
			rules: {
                name: [{ required: true, message: '系列名称不能为空', trigger: 'blur' }],
                typeId: [{ required: true, message: '请选择所属类型', trigger: 'blur' }],
				hasReplace: [{ required: true, message: '请选择状态', trigger: 'blur' }],
				frontVisible: [{ required: true, message: '请选择前端是否显示', trigger: 'blur' }],
				//img: [{ required: true, message: '请上传图片', trigger: 'blur' }]
            },
			uploadUrl : "/image/upload/19",
			fileList:[],
			productSeriesDetail:{},
			activeName:"baseTab",
			exportIsShow:false,
			imgPrefix:"/image",
			controll:{},
			exportQuery:{},
			exportVisible:false,
			progressAge:false,
			buildBarVisible:false
        };
    },
    created() {
	    this.controll = getControll("product-series");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/19";
		this.getProductTypeKV();
		this.getBrandKV();
        this.getData();
		this.baseEditorOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/12",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				//token: sessionStorage.token,  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '产品描述',  // 可选参数 富文本框内的提示语
				//theme: '',  // 可选参数 富文本编辑器的风格
				//toolOptions: [],  // 可选参数  选择工具栏的需要哪些功能  默认是全部
				//handlers: {}  // 可选参数 重定义的事件，比如link等事件
			}
		}),
		this.paramEditorOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/13",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '参数说明'
			}
		}),
		this.purposeEditorOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/14",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '用途描述'
			}
		}),
		this.partsEditorOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/15",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '配件说明'
			}
		}),
		window.addEventListener('htmlBuildProgressInProductSeries', this.progressChange);
    },
	destroyed() {
		window.removeEventListener('htmlBuildProgressInProductSeries', this.progressChange)
	},
	components: {
		quillEditor,
		quillRedefine
	},
    methods: {	
		productTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.productTypeKV.length; i++) {
				if (this.productTypeKV[i].key === cellValue){
					return this.productTypeKV[i].value;
				}
			}
			return cellValue;
		},
		brandFormat(row, column, cellValue) {
			for (var i = 0; i < this.manufacturerKV.length; i++) {
				if (this.manufacturerKV[i].key === cellValue){
					return this.manufacturerKV[i].value;
				}
			}
			return cellValue;
		},
		getProductTypeKV() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		getBrandKV() {
			getManufacturerKV().then(res => {
				if (res.code == 0 ) {
					this.manufacturerKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		statusFormat(row, column, cellValue) {
			if (typeof(cellValue) == undefined) return cellValue;
			return cellValue?"已停产":"在产"; 
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchProductSeriesData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteProductSeries([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteProductSeries(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.productSeriesDetail = {};
			this.fileList = [];
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.fileList = [];
			this.productSeriesDetail = {};
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			getProductSeries(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.productSeriesDetail = res.data.productSeriesDetail;
					if (typeof(res.data.img) != "undefined") {
						let json = {};
						json['url'] = this.imgPrefix + res.data.img;
						this.fileList.push(json);
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.form['productSeriesDetail'] = this.productSeriesDetail;
					saveProductSeries(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//文件上传
		uploadSuccess(response, file, fileList) {
			this.form.img = response.data;
		},
		//删除图片
		handleRemove(file, fileList) {
			if (!this.form.img) {
				return;
			}
			removeImg([this.form.img]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		handleExport() {
			this.exportQuery = {"exportSeries":true,"exportMapping":false,"exportProductHTML":false};
			this.exportVisible = true;
		},		
		exportData() {
			if (this.exportQuery["exportProductHTML"]) {
				this.$confirm('确定要同时生成html页面吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.exportProductSeriesXML();
					buildHTML(this.query).then(res => {
						if (res.code == 0) {
							this.progressAge = 0;
							this.buildBarVisible = true;
						} else {
							this.$message.error(`提交生成html请求失败！` + res.message);
						}
					});
				})
				.catch(() => {});
			} else {
				this.exportProductSeriesXML();
			}
		},
		exportMapping() {
			const loading = this.$loading({
			  lock: true,
			  text: '正在生成...',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.7)'
			});
			buildMapping(this.query).then(res => {
				if (res.code == 0) {
					loading.close();
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-mapping?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`生成失败！` + res.message);
				}
			});
		},
		exportProductSeriesXML() {
			exportProductSeries(this.query).then(res => {
				if (res.code == 0) {
					this.$message.success(`生成XML数据成功！`);
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-xml?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
					if (this.exportQuery["exportMapping"]) {
						this.exportMapping();
					}
				} else {
					this.$message.error(`导出失败！` + res.message);
				}
			})
		},
		progressChange(message) {
			let messageData = JSON.parse(message.detail);
			this.progressAge = Math.trunc(parseFloat(messageData.data.content) * 100);
			if (this.progressAge >= 100) {
				this.buildBarVisible = false;
				this.openFullScreen(messageData.data.key);
			}
		},
		openFullScreen(key) {
			const loading = this.$loading({
				lock: true,
				text: '下载准备中，请稍等片刻...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			const downloadKey = key;
			setTimeout(() => {
				loading.close();
				var linkTag = document.createElement("a");
				linkTag.href = "/blob/export/download-html?key=" + downloadKey;			
				linkTag.click();
				linkTag.remove();
			}, 8000);
        },
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
